// src/components/admin/AdminDashboard.jsx  
import React, { useEffect, useState } from "react";  
import { Outlet, useNavigate, useLocation } from "react-router-dom";  
import AdminSidebar from "./AdminSidebar";  
import AdminHeader from "./AdminHeader";  
import { motion, AnimatePresence } from "framer-motion";  
  
const AdminDashboard = () => {  
  const navigate = useNavigate();  
  const location = useLocation();  
  const [collapsed, setCollapsed] = useState(false);  
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);  
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);  
  
  const handleLogout = () => {  
    localStorage.removeItem("access_token");  
    localStorage.removeItem("is_superuser");  
    navigate("/login");  
  };  
  
  useEffect(() => {  
    if (localStorage.getItem("is_superuser") !== "true") navigate("/dashboard");  
  }, [navigate]);  
  
  useEffect(() => {  
    const handleResize = () => {  
      const mobile = window.innerWidth < 1024;  
      setIsMobile(mobile);  
      if (!mobile) setMobileMenuOpen(false);  
    };  
    window.addEventListener("resize", handleResize);  
    return () => window.removeEventListener("resize", handleResize);  
  }, []);  
  
  useEffect(() => setMobileMenuOpen(false), [location.pathname]);  
  
  const toggleSidebar = () => {  
    if (isMobile) setMobileMenuOpen(!mobileMenuOpen);  
    else setCollapsed(!collapsed);  
  };  
  
  return (  
    <div className="flex min-h-screen bg-black text-white overflow-hidden">  
      {/* Ambient background — matches user pages */}  
      <div className="fixed inset-0 pointer-events-none">  
        <div className="absolute -top-40 -right-40 w-[500px] h-[500px] bg-gold/[0.04] rounded-full blur-3xl" />  
        <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] bg-yellow-600/[0.04] rounded-full blur-3xl" />  
      </div>  
  
      {/* Mobile overlay */}  
      <AnimatePresence>  
        {isMobile && mobileMenuOpen && (  
          <motion.div  
            initial={{ opacity: 0 }}  
            animate={{ opacity: 1 }}  
            exit={{ opacity: 0 }}  
            onClick={() => setMobileMenuOpen(false)}  
            className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40 lg:hidden"  
          />  
        )}  
      </AnimatePresence>  
  
      <AdminSidebar  
        collapsed={collapsed}  
        isMobile={isMobile}  
        mobileMenuOpen={mobileMenuOpen}  
        toggleSidebar={toggleSidebar}  
        handleLogout={handleLogout}  
      />  
  
      <div  
        className={`flex-1 flex flex-col min-h-screen transition-all duration-300 ${  
          !isMobile && !collapsed ? "lg:ml-64" : !isMobile ? "lg:ml-16" : ""  
        }`}  
      >  
        <AdminHeader toggleSidebar={toggleSidebar} handleLogout={handleLogout} isMobile={isMobile} />  
  
        <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8 relative z-10">  
          <AnimatePresence mode="wait">  
            <motion.div  
              key={location.pathname}  
              initial={{ opacity: 0, y: 12 }}  
              animate={{ opacity: 1, y: 0 }}  
              exit={{ opacity: 0, y: -8 }}  
              transition={{ duration: 0.2 }}  
            >  
              <Outlet />  
            </motion.div>  
          </AnimatePresence>  
        </main>  
      </div>  
    </div>  
  );  
};  
  
export default AdminDashboard;  